import { render } from "./MenuItemLoader.vue?vue&type=template&id=60aae775"
import script from "./MenuItemLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemLoader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/MenuItemLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60aae775"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60aae775', __exports__)) {
    api.reload('60aae775', __exports__)
  }
  
  module.hot.accept("./MenuItemLoader.vue?vue&type=template&id=60aae775", () => {
    api.rerender('60aae775', render)
  })

}


export default __exports__